import {EMAIL_PERSONAL_DOMAIN_REGEX} from './workEmail'
import {PHONE_REGEX} from './phone'

export default {
  EMAIL_PERSONAL_DOMAIN_REGEX,
  PHONE_REGEX,
}
